import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import * as R from "ramda";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import {
  getGlassList,
  getGroupProductGlass,
  getSpacerList,
  InsertMahsooleShisheData,
  getJedareList,
  GetAllMahsooleShishe,
  changeMahsooleShisheSearch,
  getColorList,
} from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { DialogActions, Divider } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import MuiColorAutoComplete from "Components/MuiColorAutoComplete/MuiColorAutoComplete";
import { ReactSVG } from "react-svg";
import infoIcon from "Assets/svg/icon/info.svg";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function InsertMahsooleShishe() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const {
    groupGlassList,
    glassList,
    spacerList,
    jedareList,
    colorList,
    mahsooleShishePagination,
  } = useSelector((state) => ({
    groupGlassList: state.shishe.groupGlassList,
    glassList: state.shishe.glassList,
    spacerList: state.shishe.spacerList,
    jedareList: state.shishe.jedareList,
    colorList: state.shishe.colorList,
    mahsooleShishePagination: state.shishe.mahsooleShishePagination,
  }));

  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [ListPart, setListPart] = useState(null);
  const [suggestedPrice, setSuggestedPrice] = useState(0);
  const [controls, setControls] = useSetState({
    nameshishe: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    shisheGroup: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
    },
    jedare: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
    },
    color: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
    },
    price: {
      type: "price",
      value: "",
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  useEffect(() => {
    setControls({ shisheGroup: { value: groupGlassList[0] } });
    setControls({ shisheGroup: { selectItems: groupGlassList } });
    setControls({ jedare: { value: jedareList[0] } });
    setControls({ jedare: { selectItems: jedareList } });
  }, [jedareList, groupGlassList]);

  useEffect(() => {
    setControls({ color: { selectItems: colorList } });
    setControls({ color: { value: colorList[0] } });
  }, [colorList]);

  useEffect(() => {
    if (controls.jedare.value?.Id === 1) {
      setListPart([{ IdPart: glassList[0], Stype: 1, selectItems: glassList }]);
    } else if (controls.jedare.value?.Id === 2) {
      setListPart([
        { IdPart: glassList[0], Stype: 1, selectItems: glassList },
        { IdPart: spacerList[0], Stype: 2, selectItems: spacerList },
        { IdPart: glassList[0], Stype: 1, selectItems: glassList },
      ]);
    } else if (controls.jedare.value?.Id === 3) {
      setListPart([
        { IdPart: glassList[0], Stype: 1, selectItems: glassList },
        { IdPart: spacerList[0], Stype: 2, selectItems: spacerList },
        { IdPart: glassList[0], Stype: 1, selectItems: glassList },
        { IdPart: spacerList[0], Stype: 2, selectItems: spacerList },
        { IdPart: glassList[0], Stype: 1, selectItems: glassList },
      ]);
    }
  }, [controls.jedare]);

  useEffect(() => {
    if (ListPart) {
      let total = 0;
      for (let i = 0; i < ListPart.length; i++) {
        total = total + ListPart[i].IdPart.Price;
      }
      setSuggestedPrice(total);
    }
  }, [ListPart]);

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (ListPart && ListPart.length >= 0) {
      const { price, jedare, nameshishe, shisheGroup, color } = controls;
      let updateListPart = [];
      for (let i = 0; i < ListPart.length; i++) {
        updateListPart.push({
          IdPart: ListPart[i].IdPart.Id,
          Stype: ListPart[i].Stype,
        });
      }
      if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
      ) {
        try {
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: nameshishe.value,
            IdSwall: +jedare.value.value,
            Price: +price.value,
            IdGroupProductGlass: +shisheGroup.value.value,
            ListPart: updateListPart,
            ColorPattern: color.value.value,
          };

          await dispatch(InsertMahsooleShisheData(data));
          dispatch(changeMahsooleShisheSearch({ Name: "" }));
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Limit: mahsooleShishePagination.Limit,
            Page: 1,
          };
          await dispatch(GetAllMahsooleShishe(params));
          handleDialog();
          onClear();
        } catch (err) {
          console.error("[catch error]", err);
        }
      } else {
        setCheckValid(true);
      }
    }
    setLoading(false);
  };
  const onClear = () => {
    setCheckValid(false);
    setFormValid({ nameshishe: false, price: false });
    setListPart(null);
    setSuggestedPrice(0);
    setControls({ nameshishe: { value: "" } });
    setControls({ shisheGroup: { value: "" } });
    setControls({ jedare: { value: "" } });
    setControls({ color: { value: "" } });
    setControls({ price: { value: "" } });
  };
  const onEnter = async () => {
    onClear();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
      };
      await dispatch(getGlassList(params));
      await dispatch(getSpacerList(params));
      await dispatch(getGroupProductGlass(params));
      await dispatch(getJedareList(params));
      await dispatch(getColorList(params));
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const onListPartChange = (e, value) => {
    const index = +e.target.id.split("-")[0];
    const arr = [];
    arr.push(...ListPart);
    arr[index].IdPart = value;
    setListPart(arr);
  };

  const autoCompleteColorHandler = async (e, value, controlName) => {
    setValue(controlName, value, true);
    // setControls({ [controlName]: { value: value } });
    // setFormValid((prev) => ({ ...prev, [controlName]: true }));
  };

  const handleSuggestionPriceClick = (e) => {
    e.preventDefault();
    if (suggestedPrice && suggestedPrice !== 0) {
      setValue("price", suggestedPrice.toString(), true);
    }
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"new_glass_product"} />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"new_glass_product"} />}</p>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Input
                  setValue={setValue.bind(this)}
                  name={"nameshishe"}
                  validation={controls.nameshishe.validation}
                  placeholder={t("nameshishe")}
                  label={<Translator id={"nameshishe"} />}
                  value={controls.nameshishe.value}
                  type="text"
                  checkValid={checkValid}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MuiAutoComplete
                  autoSelect={true}
                  loading={loading}
                  className="mt-2"
                  options={controls.shisheGroup.selectItems}
                  label={<Translator id={"shisheGroup"} />}
                  value={controls.shisheGroup.value}
                  id={"shisheGroup"}
                  onChange={autoCompleteHandler}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MuiColorAutoComplete
                  autoSelect={true}
                  loading={loading}
                  className="mt-2"
                  options={controls.color.selectItems}
                  label={<Translator id={"color"} />}
                  value={controls.color.value}
                  id={"color"}
                  onChange={(e, value) =>
                    autoCompleteColorHandler(e, value, "color")
                  }
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MuiAutoComplete
                  autoSelect={true}
                  loading={loading}
                  options={controls.jedare.selectItems}
                  label={<Translator id={"jedare"} />}
                  value={controls.jedare.value}
                  id={"jedare"}
                  onChange={autoCompleteHandler}
                />
              </Grid>
              {ListPart?.map((item, i) => {
                return (
                  <Grid item sm={6} xs={12} key={"m-" + i}>
                    <MuiAutoComplete
                      autoSelect={true}
                      loading={loading}
                      options={item.selectItems}
                      label={
                        item.Stype === 1 ? (
                          <Translator id={"shishe"} />
                        ) : (
                          <Translator id={"spacer"} />
                        )
                      }
                      value={item.IdPart}
                      id={`${i}`}
                      onChange={onListPartChange}
                    />
                  </Grid>
                );
              })}
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12} className="mt-4">
                <Input
                  setValue={setValue.bind(this)}
                  value={controls.price.value}
                  name={"price"}
                  placeholder={t("price")}
                  validation={controls.price.validation}
                  checkValid={checkValid}
                  label={<Translator id={"price"} />}
                  type={controls.price.type}
                  endIcon={<Translator id="moneyUnit" />}
                />
              </Grid>
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  variant="outlined"
                  icon={<ReactSVG src={infoIcon} />}
                >
                  <p onClick={handleSuggestionPriceClick} className="handC">
                    {`${t("suggestionPrice")} :`}
                    <strong className="mx-1">
                      {suggestedPrice.toLocaleString()}
                    </strong>
                    {t("moneyUnit")}
                  </p>
                </Alert>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
              disabled={loading}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
              disabled={loading}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default InsertMahsooleShishe;
